const HERO_IMAGE =
  'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?auto=format&fit=crop&w=1600&q=80';

const RELATED_GUIDES = [
  {
    slug: 'soccer-goalkeeper-drills-free-youtube-videos',
    title: 'Soccer Goalkeeper Drills + Free YouTube Training Videos',
    blurb: 'shot stopping and distribution.',
  },
  {
    slug: 'soccer-defender-drills-free-youtube-videos',
    title: 'Soccer Defender Drills + Free YouTube Training Videos',
    blurb: '1v1 defending and positioning.',
  },
];

/** Featured guide: forward and striker drills with free YouTube training videos */
export const FORWARD_DRILLS_POST = {
  id: 'featured-forward-drills-youtube',
  slug: 'soccer-forward-striker-drills-free-youtube-videos',
  title: 'Soccer Forward & Striker Drills + Free YouTube Videos',
  excerpt:
    'Finishing, first touch, movement off the ball, 1v1 attacking, and shooting—drill ideas for wingers and strikers with links to famous free YouTube sessions.',
  publishedAt: '2026-07-22T00:40:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'Forward Training Desk',
  blogCategory: 'exercise',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'exercise',
  relatedPostsTitle: 'More position training guides',
  relatedPosts: RELATED_GUIDES,
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Guide overview',
      items: [
        { value: '7 areas', label: 'Finishing · Touch · Movement · More' },
        { value: '18+', label: 'Drill ideas' },
        { value: '10', label: 'Free YouTube sessions' },
        { value: 'All levels', label: 'Rec to competitive' },
      ],
    },
    {
      type: 'panel',
      title: 'How to use this guide',
      paragraphs: [
        'Built for strikers, wingers, and attacking mids who want more goals and sharper movement. Field drills need one server and a few balls; YouTube links are all free from channels like Unisport, AllAttack, and ZTH Training.',
        'Quality reps beat volume—focus on clean technique first, then add speed and pressure.',
      ],
      chips: ['Free on YouTube', 'Solo or partner', 'Rec & club', 'Ohio teams'],
    },
    {
      type: 'panel',
      title: '1 — First touch & ball control',
      list: [
        'Wall pass: one touch back, turn, pass again—alternate feet for 2 minutes.',
        'Cone weave: dribble through 5 cones, final touch into shooting lane.',
        'Air ball control: server tosses; take with chest, thigh, or lace to ground.',
        'Turn on pressure: receive with defender shadowing; open body to play forward in one touch.',
        'Weak-foot only: 10 passes and 10 shots with non-dominant foot.',
      ],
    },
    {
      type: 'videoList',
      title: 'YouTube — touch and control',
      videos: [
        {
          title: '1v1 Soccer Drill with a focus on evading defenders on your back',
          channel: 'First Strike Soccer',
          description: 'Shielding and turning under pressure—useful for hold-up strikers.',
          url: 'https://www.youtube.com/watch?v=Ed_1EmXu_WA',
        },
        {
          title: 'The PERFECT striker drill to do with a friend',
          channel: 'Unisport',
          description: 'Partner passing pattern that builds touch and quick finishes.',
          url: 'https://www.youtube.com/watch?v=UZ97QZxLca0',
        },
      ],
    },
    {
      type: 'panel',
      title: '2 — Finishing in the box',
      list: [
        'Near-post run: time arrival for cut-back; one-touch finish across goal.',
        'Far-post loop: start central, curve run to back post for crossed ball.',
        'Rebound hunt: after shot, sprint for any spill—tap-ins count.',
        '3-zone finishing: shoot from left, center, and right angles inside 18 yds.',
        'One-touch only: server plays in; no extra touches inside box.',
      ],
    },
    {
      type: 'videoList',
      title: 'YouTube — finishing drills',
      videos: [
        {
          title: 'Finishing Drills For Strikers | How To Score Goals In The Box',
          channel: 'Coach Lerche',
          description: 'Box movement and composure in front of goal.',
          url: 'https://www.youtube.com/watch?v=WE7ffE-SF-Y',
        },
        {
          title: 'AN ACADEMY FOOTBALLERS TOP 3 FINISHING DRILLS',
          channel: 'ZTH Training',
          description: 'Three academy-level patterns for clinical finishing.',
          url: 'https://www.youtube.com/watch?v=8Y5d3GAPy-4',
        },
        {
          title: '7 Ways to Score MORE GOALS in SOCCER/FOOTBALL',
          channel: 'AllAttack',
          description: 'Popular overview of movement and finishing habits (millions of views).',
          url: 'https://www.youtube.com/watch?v=NrRoUK3ZsnU',
        },
      ],
    },
    {
      type: 'panel',
      title: '3 — Shooting technique',
      list: [
        'Placement over power: pick corners on full-size goal; 10 shots each side.',
        'Instep drive: lock ankle, strike through center of ball, follow through to target.',
        'Curled finish: wrap foot around ball for far corner from edge of box.',
        'Volley progression: self toss → partner toss → crossed ball.',
        'Weak-foot finishes: 15 shots from 12 yds—no excuses on match day.',
      ],
    },
    {
      type: 'videoList',
      title: 'YouTube — shooting',
      videos: [
        {
          title: 'How To Improve Your Shooting FAST (7 Drills)',
          channel: 'ZTH Training',
          description: 'Seven progressive shooting drills from basic to game speed.',
          url: 'https://www.youtube.com/watch?v=4YJx-UjzgnE',
        },
      ],
    },
    {
      type: 'panel',
      title: '4 — Movement off the ball',
      list: [
        'Check-to: sprint to ball, lay off, spin behind defender into space.',
        'Blind-side run: when winger has ball, arc run outside defender’s view.',
        'Pull wide / pull central: drag center back out, then attack space behind.',
        'Third-man runs: pass wide, sprint through middle as wall pass happens.',
        'Press trigger then break: when team wins ball, sprint 10 yds into channel.',
      ],
    },
    {
      type: 'videoList',
      title: 'YouTube — striker movement',
      videos: [
        {
          title: 'Become a better striker with these 5 drills!',
          channel: 'Unisport',
          description: 'Five staple drills for movement, touch, and finishing.',
          url: 'https://www.youtube.com/watch?v=n-P_Gu29TM8',
        },
        {
          title: 'Do this weekly and become a goal machine',
          channel: 'Unisport',
          description: 'Weekly striker routine for consistent goal scoring.',
          url: 'https://www.youtube.com/watch?v=sfP9nVmU9sY',
        },
      ],
    },
    {
      type: 'panel',
      title: '5 — 1v1 attacking',
      list: [
        'Take-on to finish: dribble at defender, single skill move, shoot within 5 sec.',
        'Speed to space: knock ball past defender on heavy touch, sprint to goal.',
        'Cut inside: from wing, chop inside onto shooting foot—aim far post.',
        'Fake shot: drop shoulder, take touch wide, cross or cut back.',
        'Channel 1v1: two mini goals wide; attacker chooses side after skill.',
      ],
    },
    {
      type: 'panel',
      title: '6 — Heading & crosses',
      list: [
        'Near-post header: attack front of 6-yard box on inswinging cross.',
        'Glancing header: redirect cross across goal instead of straight on.',
        'Jump timing: two-step approach, eyes open, contact on forehead.',
        'Cross and finish: winger serves; striker makes near- and far-post runs alternating.',
      ],
    },
    {
      type: 'panel',
      title: '7 — Sample 60-minute striker session',
      orderedList: [
        '10 min — first touch and wall passes (section 1).',
        '15 min — box finishing—one-touch and two-touch (section 2).',
        '10 min — shooting from edge of box (section 3).',
        '15 min — 1v1 to goal with defender (sections 4–5).',
        '10 min — crossing and heading or cool-down jog.',
      ],
      callout:
        'Need a field? See our guide to open soccer parks near Powell, Dublin, Lewis Center, and Delaware.',
    },
  ],
  referenceLinks: [
    {
      label: 'Unisport — YouTube channel',
      url: 'https://www.youtube.com/@Unisport',
    },
    {
      label: 'AllAttack — YouTube channel',
      url: 'https://www.youtube.com/@AllAttack',
    },
    {
      label: 'ZTH Training — YouTube channel',
      url: 'https://www.youtube.com/@ZTHTraining',
    },
    {
      label: 'Open soccer fields near Powell, Dublin, Lewis Center & Delaware',
      url: 'https://dailysportslife.com/blog/open-soccer-fields-powell-dublin-lewis-center-delaware-ohio',
    },
  ],
};
